/**
 * dem50-Specific Display Configuration for SPLH Dashboard
 *
 * Override default configuration with dem50-specific display preferences.
 * This file only contains DISPLAY settings that differ from default.
 *
 * @module pages/common/dashboards/SPLHDashboard/config/dem50
 */

/**
 * dem50-specific configuration overrides
 * @type {Object}
 */
const dem50Config = {
  // Currently using all default settings
  // Add dem50-specific overrides here as needed
  // Example:
  // display: {
  //   chartColors: {
  //     splh: '#custom-color',
  //   },
  // },
};

export default dem50Config;
